"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountMemberResponseToJSON = exports.AdAccountMemberResponseFromJSONTyped = exports.AdAccountMemberResponseFromJSON = exports.instanceOfAdAccountMemberResponse = void 0;
var runtime_1 = require("../runtime");
var AdAccountRole_1 = require("./AdAccountRole");
/**
 * Check if a given object implements the AdAccountMemberResponse interface.
 */
function instanceOfAdAccountMemberResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdAccountMemberResponse = instanceOfAdAccountMemberResponse;
function AdAccountMemberResponseFromJSON(json) {
    return AdAccountMemberResponseFromJSONTyped(json, false);
}
exports.AdAccountMemberResponseFromJSON = AdAccountMemberResponseFromJSON;
function AdAccountMemberResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'memberId': !(0, runtime_1.exists)(json, 'member_id') ? undefined : json['member_id'],
        'role': !(0, runtime_1.exists)(json, 'role') ? undefined : (0, AdAccountRole_1.AdAccountRoleFromJSON)(json['role']),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'emailAddress': !(0, runtime_1.exists)(json, 'email_address') ? undefined : json['email_address'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
    };
}
exports.AdAccountMemberResponseFromJSONTyped = AdAccountMemberResponseFromJSONTyped;
function AdAccountMemberResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'member_id': value.memberId,
        'role': (0, AdAccountRole_1.AdAccountRoleToJSON)(value.role),
        'name': value.name,
        'email_address': value.emailAddress,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'ad_account_id': value.adAccountId,
    };
}
exports.AdAccountMemberResponseToJSON = AdAccountMemberResponseToJSON;
